import { usePatchAnnotations } from './usePatchAnnotations';

type SetTrainingEnabledParams = {
  annotationIds: number[];
  enabled: boolean;
  onSuccess?: () => void;
  onSettled?: () => void;
  onError?: () => void;
};

export const getNextTrainingEnabledValue = (
  annotations: Array<{ training_enabled?: boolean }>
): boolean => annotations.some(a => a.training_enabled === false);

export const useSetTrainingEnabled = () => {
  const { mutate, isLoading } = usePatchAnnotations();

  const setTrainingEnabled = ({
    annotationIds,
    enabled,
    onSuccess,
    onSettled,
    onError,
  }: SetTrainingEnabledParams) => {
    mutate(
      annotationIds.map(id => ({
        id,
        payload: { trainingEnabled: enabled },
      })),
      { onSuccess, onSettled, onError }
    );
  };

  return { setTrainingEnabled, isLoading };
};
